import GoToAppOrStore, { BtnConfig } from '@/components/GoToAppOrStore';
import Constants from '@/Constants';
import { IntegrationLoginData } from '@/models/LoginData';
import { clearAuth } from '@/services/IdentityService';
import { redirectToStore } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { authClear, authIntegrationRequest } from '@/store/identity/action';
import React, { useEffect, useRef, useState } from 'react';
import { isAndroid, isIOS, isMobileOnly } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Dispatch } from 'redux';

const Integration: React.FC = () => {
    const { hasError, user, organization, strings } = useSelector((state: ApplicationState) => ({
        hasError: state.identity.hasError,
        user: state.identity.data.user,
        organization: state.appOrganization.data.organization,
        strings: state.locale.data,
    }));

    const [authInProgress, setAuthInProgress] = useState<boolean>(false);
    const [customBtnConfig, setCustomBtnConfig] = useState<BtnConfig>();
    const goToAppBtn = useRef<HTMLAnchorElement>(null);

    const dispatch: Dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const removePrevAuthIfExists = () => {
        clearAuth();
        dispatch(authClear());
    };

    const executeGoToAppBtnClick = (params: URLSearchParams) => {
        if (goToAppBtn.current) {
            goToAppBtn.current.href = Constants.mobileApp.APP_INTEGRATION_DEEP_LINK + '?orgId=' + organization.id + '&' + params.toString();
            goToAppBtn.current.click();
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const loginQS = params.get('login');
        const accessQS = params.get('access');
        const tokenQS = params.get('token');

        if (isMobileOnly && (isAndroid || isIOS)) {
            executeGoToAppBtnClick(params);
            setCustomBtnConfig({
                label: strings.CLICK_TO_ACCESS_APP,
                action: () => {
                    isAndroid && setTimeout(() => redirectToStore(false), 2000);
                    executeGoToAppBtnClick(params);
                },
            });
        } else if (loginQS && accessQS && tokenQS) {
            const integrationLoginData: IntegrationLoginData = {
                orgId: organization.id,
                applicationId: Constants.APP_ID,
                login: loginQS,
                token: tokenQS,
                access: accessQS,
            };
            removePrevAuthIfExists();
            setAuthInProgress(true);
            dispatch(authIntegrationRequest(integrationLoginData));
        } else {
            history.push('/logout');
        }
    }, [dispatch]);

    useEffect(() => {
        if (hasError) {
            history.push('/logout');
        }
    }, [hasError]);

    useEffect(() => {
        if (authInProgress && user) {
            history.push('/login?auth=1');
        }
    }, [authInProgress, user]);

    return (
        <>
            <a hidden ref={goToAppBtn} />
            <GoToAppOrStore customBtnConfig={customBtnConfig} />
        </>
    );
};

export default Integration;
